import { useEffect, useState } from 'react';
import { walletHttp } from 'shared/api/wallet-axios';
/**
 * Loads accounting currency codes for limit form dropdowns and card issuance (independent of card-limit Redux slice).
 */
export function useAccCurrencyOptions() {
    const [options, setOptions] = useState([]);
    useEffect(() => {
        let cancelled = false;
        walletHttp()
            .get('accounting/api/acc-currencies')
            .then(res => {
            const list = Array.isArray(res.data) ? res.data : [];
            const opts = list
                .map(c => {
                const code = (c.code ?? c.name ?? '').trim();
                return code ? { name: code, value: code } : null;
            })
                .filter((o) => o != null);
            if (!cancelled) {
                setOptions(opts);
            }
        })
            .catch(() => {
            if (!cancelled) {
                setOptions([]);
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    return options;
}
/** Full currency rows (with id) for entity references, e.g. card issuance. */
export function useAccCurrencyRows() {
    const [rows, setRows] = useState([]);
    useEffect(() => {
        let cancelled = false;
        walletHttp()
            .get('accounting/api/acc-currencies')
            .then(res => {
            const list = Array.isArray(res.data) ? res.data : [];
            if (!cancelled) {
                setRows(list);
            }
        })
            .catch(() => {
            if (!cancelled) {
                setRows([]);
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    return rows;
}
